export default __webpack_public_path__ + "static/media/beginners1.631e9c99.png";